module.exports = __webpack_public_path__ + "static/img/icon_pc.089f922a.png";